module.exports = __webpack_public_path__ + "assets/spec_phone_background.ed70ff98bf9792c3adfbb979c46cc4e2.jpg";